import {defaultImg} from '../../../utils/defaultImg';

/* eslint-disable require-jsdoc */
function getBandImage(image) {
  const validImage = image != '' && image != 'None';
  return validImage ? image : defaultImg();
}

export {getBandImage};
